import React from 'react';
import classnames from 'classnames';
import { string, bool, shape, number, func } from 'prop-types';
import { Card } from '@andes/card';
import { track } from '../../helpers';

import ZipCode from '../ZipCode';
import StateCity from '../StateCity';
import IconLink from './IconLink';
import Plus from '../icons/Plus';
import Pin from '../icons/Pin';


const namespace = 'another-location';

const AnotherLocation = ({
  appId,
  zipCode,
  zipCodeValidations,
  stateCity,
  deviceType,
  hasAddresses,
  backUrl,
  isFlow,
  isEmbed,
  isModal,
  createAction,
  selectedLocationLabel,
  selectLocationLabel,
  isLoggedIn,
  translations,
  selectedCP,
  zipCodeChanged,
  zipCodeSubmitted,
  cityChanged,
  stateChanged,
  stateCitySubmitted,
  selectedAddress,
  webView,
  shouldRenderExternalLinks,
  ...sharedProps
}) => {
  let title;
  let componentLocation;
  let componentLocationLink;
  let componentChangeLocationLink;

  const handleNewAddressClick = () => {
    track('hub', 'create_address', { app: appId });
  };

  const classes = classnames(namespace, {
    [`${namespace}--not-logged`]: !isLoggedIn,
  });

  const secondaryCardClasses = classnames('secondary-card', {
    'secondary-card-embed': isEmbed,
  });

  const componentNewAddress = isLoggedIn && <div className="icon-link__content--link">{translations.newAddress}</div>;
  const changeLocationClick = (e) => {
    if (window.MobileWebKit.engine === window.MobileWebKit.Engines.V200) {
      e.preventDefault();
      window.MobileWebKit.navigation.push(zipCode ? zipCode.newLocationLink : stateCity.newLocationLink, {
        screens_group: 'addressHubGroup',
      });
    }
  };
  if (deviceType === 'mobile' && isLoggedIn && hasAddresses) {
    title = translations.anotherLocation;
    if (selectedCP && !selectedAddress) {
      componentChangeLocationLink = (
        <>
          <span className="selected-zipcode">
            {selectedLocationLabel.title}{' '}
            <span className="selected-zipcode__address">{selectedLocationLabel.label}</span>
          </span>
          <a
            className="icon-link__content--link"
            {...(webView && {
              onClick: changeLocationClick,
            })}
            href={zipCode ? zipCode.newLocationLink : stateCity.newLocationLink}
          >
            {zipCode ? translations.changeCP : translations.change}
          </a>
        </>
      );
    } else {
      componentLocationLink = <div className="icon-link__content--link">{selectLocationLabel}</div>;
    }
  } else if (zipCode) {
    title = isLoggedIn ? zipCode.title : null;
    componentLocation = (
      <ZipCode
        webView={webView}
        {...zipCode}
        {...sharedProps}
        deviceType={deviceType}
        zipCodeValidations={zipCodeValidations}
        hasAddresses={hasAddresses}
        isLoggedIn={isLoggedIn}
        translations={translations}
        selectedAddress={selectedAddress}
        zipCodeSubmitted={zipCodeSubmitted}
        zipCodeChanged={zipCodeChanged}
      />
    );
  } else {
    title = isLoggedIn ? stateCity.title : null;
    componentLocation = (
      <StateCity
        {...stateCity}
        {...sharedProps}
        deviceType={deviceType}
        translations={translations}
        isLoggedIn={isLoggedIn}
        selectedAddress={selectedAddress}
        stateCitySubmitted={stateCitySubmitted}
        cityChanged={cityChanged}
        stateChanged={stateChanged}
      />
    );
  }

  return (
    <div className={classes}>
      <h2 className="header-subtitle">{title}</h2>
      <Card className={secondaryCardClasses}>
        {componentLocation}
        {componentLocationLink && (
          <a
            {...(webView && {
              onClick: changeLocationClick,
            })}
            href={zipCode ? zipCode.newLocationLink : stateCity.newLocationLink}
            data-testid="navigate-zipcode"
          >
            <IconLink className={`${namespace}__link`} content={componentLocationLink} icon={<Pin />} />
          </a>
        )}
        {componentChangeLocationLink && (
          <IconLink className={`${namespace}__link`} content={componentChangeLocationLink} icon={<Pin />} />
        )}
        {componentNewAddress && createAction && (
          <a
            className={`${namespace}__link`}
            href={createAction.action}
            onClick={handleNewAddressClick}
            target="_parent"
            data-testid="create-address"
            aria-label={translations.newAddress}
          >
            <IconLink content={componentNewAddress} icon={<Plus />} />
          </a>
        )}
      </Card>
    </div>
  );
};

AnotherLocation.propTypes = {
  deviceType: string.isRequired,
  appId: string,
  zipCodeValidations: shape({
    maxLength: number.isRequired,
  }).isRequired,
  isFlow: bool.isRequired,
  zipCode: shape({
    title: string,
  }),
  stateCity: shape({
    title: string,
  }),
  createAction: shape({
    action: string,
  }),
  backUrl: string,
  hasAddresses: bool.isRequired,
  isEmbed: bool.isRequired,
  selectedLocationLabel: shape({
    title: string.isRequired,
    label: string,
  }),
  isModal: bool.isRequired,
  selectLocationLabel: string.isRequired,
  isLoggedIn: bool.isRequired,
  translations: shape({
    newAddress: string.isRequired,
    change: string.isRequired,
    anotherLocation: string.isRequired,
  }).isRequired,
  selectedCP: string,
  zipCodeSubmitted: func,
  zipCodeChanged: func,
  stateCitySubmitted: func,
  cityChanged: func,
  stateChanged: func,
  selectedAddress: number,
  webView: bool.isRequired,
  shouldRenderExternalLinks: bool.isRequired,
  analytics: shape({
    dimensions: shape({}),
  }),
  melidata: shape({
    event_data: shape({}),
  }),
};

AnotherLocation.defaultProps = {
  zipCode: null,
  stateCity: null,
  createAction: null,
  backUrl: '',
  selectedLocationLabel: null,
  selectedCP: null,
  zipCodeSubmitted: null,
  zipCodeChanged: null,
  stateCitySubmitted: null,
  cityChanged: null,
  stateChanged: null,
  selectedAddress: null,
};

export default AnotherLocation;
